module.exports = __webpack_public_path__ + "static/media/cabin-filter-change-red.49f25528.svg";